import { useState } from 'react';
import { generateContent } from '../services/api';

export interface ContentGenerationRequest {
  transcript: string;
  tone_profile: {
    tone: string;
    structure: string;
    quirks: string[];
    vocab: string[];
  };
  platforms?: string[];
  video_url?: string; // Added to pass the YouTube URL to the backend
}

export interface GeneratedContent {
  twitter?: string;
  linkedin?: string;
  reddit?: string;
  [key: string]: string | undefined;
}

export const useContentGeneration = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generatePosts = async (request: ContentGenerationRequest): Promise<GeneratedContent> => {
    setIsLoading(true);
    setError(null);
    
    try {
      const { data } = await generateContent(request);
      return data;
    } catch (err) {
      // If err is a string, it's our custom network error message
      const errorMessage = typeof err === 'string' 
        ? err 
        : (err instanceof Error ? err.message : 'Failed to generate content');
      
      setError(errorMessage);
      throw errorMessage;
    } finally {
      setIsLoading(false);
    }
  };

  return { generatePosts, isLoading, error };
};
